/**
 * A place for all common datatable.net overrides
 */
namespace appn.dataTable {
    export const FILTER_RESET_BTN = `<button class="btn btn-tool btn-resetFilters" type="button" title="${T('Reset Filters')}"><i class="fa fa-sync-alt"></i></button>`;

    const _datatableCheckAllBoxSelector = 'table.dataTable thead tr th input[type="checkbox"]';

    /**
     * Datatable state key prefix
     * Used as the prefix for datatalbe state
     */
    export const stateKeyPrefix = 'appn.dataTablesState.' + window.location.pathname + '.';

    /**
     * Datatable generate composite state cache key
     * Suffix is for dataTables where a specific ID is needed
     * in case of multiple IDs of a table can point to a single screen
     * like Views/Data
     */
    export function getCompositeStateCacheKey(oSettings: any, suffix?: string): string {
        if (suffix)
            return appn.dataTable.stateKeyPrefix + oSettings.sInstance + suffix;

        return appn.dataTable.stateKeyPrefix + oSettings.sInstance;
    }

    export function constructDataTableFooter() {
        const dataTableWrappers = $('.card .card-body').find('.dataTables_wrapper');

        dataTableWrappers.each(function () {
            const dataTableWrapper = $(this);

            if (dataTableWrapper.find('.dataTables_footer').length)
                return;

            const $controls = dataTableWrapper.find('.dataTables_length, .dataTables_info, .dataTables_paginate');
            const $ownControls = $controls.filter(function() {
                return $(this).closest('.dataTables_wrapper').is(dataTableWrapper);
            });

            if ($ownControls.length) {
                $('<div/>', {
                    class: 'dataTables_footer'
                }).appendTo(dataTableWrapper);

                $ownControls.appendTo(dataTableWrapper.find('.dataTables_footer'));
            }
        });
    }

    export function revealDataTable() {
        constructDataTableFooter();
        $('.dataTables_filter,.dataTables_scroll,table.dataTable.table,.dataTables_length,.dataTables_info,.dataTables_paginate').css('opacity', 1); // Show once initialized to prevent default flashing
    }

    /**
     * Centralized config and common fn handling for DataTables
     * Refer http://legacy.datatables.net/ref options
     * @param selector
     * @param cfg
     */
    export function create(selector: string, cfg: any): any {
        const isServer = cfg.sAjaxSource ? true : false;

        const colResizeConfig = {
            isEnabled: true,
            saveState: false,
            hoverClass: 'dt-colresizable-hover',
            hasBoundCheck: true,
            minBoundClass: 'dt-colresizable-bound-min',
            maxBoundClass: 'dt-colresizable-bound-max'
        };

        const settingObj: any = {
            bServerSide: isServer,
            bProcessing: cfg.hasOwnProperty('bProcessing') ? cfg.bProcessing : true,
            bSort: cfg.hasOwnProperty('bSort') ? cfg.bSort : true,
            fixedHeader: cfg.hasOwnProperty('fixedHeader') ? cfg.fixedHeader : true,
            paging: cfg.hasOwnProperty('paging') ? cfg.paging : true,
            ordering: cfg.hasOwnProperty('ordering') ? cfg.ordering : true,
            info: cfg.hasOwnProperty('info') ? cfg.info : true,
            searching: cfg.hasOwnProperty('searching') ? cfg.searching : true,
            autoWidth: cfg.hasOwnProperty('autoWidth') ? cfg.autoWidth : false,
            hasFilters: cfg.hasOwnProperty('hasFilters') ? cfg.hasFilters : true,
            scrollY: cfg.hasOwnProperty('scrollY') ? cfg.scrollY : '70vh',
            scrollX: cfg.hasOwnProperty('scrollX') ? cfg.scrollX : '100%',
            sDom: cfg.hasOwnProperty('sDom') ? cfg.sDom : genSDom(),// "<'dataTables_actions'<'ratio_1_3'><'#mid'><'#right'f>>rtlip",//'<"dataTables_actions">frtlip',
            iDisplayLength: cfg.hasOwnProperty('iDisplayLength') ? cfg.iDisplayLength : 25,
            aLengthMenu: cfg.hasOwnProperty('aLengthMenu') ? cfg.aLengthMenu : [10, 25, 50, 100],
            oLanguage: {
                oPaginate: {
                    sPrevious: '<i class="fa fa-chevron-left"></i>',
                    sNext: '<i class="fa fa-chevron-right"></i>'
                },
                sInfoFiltered: cfg.hasOwnProperty('sInfoFiltered') ? cfg.sInfoFiltered : appn.emptyString,
                sSearch: appn.emptyString,
                sInfoEmpty: appn.emptyString,
                sEmptyTable: cfg.hasOwnProperty('sEmptyTable') ? cfg.sEmpty :
                    `<span class="dataTables_noData text-center lead text-gray"><span class="font-size-larger-2"><i class="fa fa-search text-danger mr-2"></i>${T('No Data Found')}</span>${(!cfg.hasOwnProperty('hasFilters') || cfg.hasFilters === true ? `<br><span class="font-size-smaller-1">${T(`Try <a href='#' class='link-reset-filters'>resetting</a> the filters`)}</span>` : emptyString)}</span>`,
                sProcessing: cfg.hasOwnProperty('sProcessing') ? cfg.sProcessing : ui.getSpinner(),
                sInfo: T("Showing _START_ to _END_ of _TOTAL_ entries"),
                sLengthMenu: T("Show _MENU_ entries")
            },
            sAjaxSource: cfg.hasOwnProperty('sAjaxSource') ? cfg.sAjaxSource : null,
            fnServerData: !isServer ? null : function (url: string, data: any, callback: Function) {
                if (cfg.fnServerData)
                    cfg.fnServerData(data, callback);

                appn.ajax.post({
                    url: url,
                    data: data,
                    done: function (data: any) {
                        callback(data);
                    },
                    fail: function (jqXHR: JQueryXHR, textStatus: string, errorThrown: any) {
                        $('div.dataTables_wrapper div.dataTables_processing').hide();
                        if (errorThrown === 'parsererror' || textStatus === 'parsererror')
                            errorThrown = T('An error occurred while retrieving data');
                        if (jqXHR.responseText && !jqXHR.responseText.startsWithIgnoreCase('<')) // ignore HTML responses
                            errorThrown = jqXHR.responseText;
                        appn.toast.notify(toast.Type.error, errorThrown);
                        revealDataTable();
                    }
                });

            },
            aaSorting: cfg.hasOwnProperty('aaSorting') ? cfg.aaSorting : [[0, 'asc']],
            aoColumns: cfg.hasOwnProperty('aoColumns') ? cfg.aoColumns : null,
            aoColumnDefs: cfg.hasOwnProperty('aoColumnDefs') ? cfg.aoColumnDefs : null,
            createdRow: cfg.hasOwnProperty('createdRow') ? cfg.createdRow : null,
            oColVis: cfg.hasOwnProperty('oColVis') ? cfg.oColVis : null,
            oColReorder: cfg.hasOwnProperty('oColReorder') ? cfg.oColReorder : null,
            fnInitComplete: function () {
                // Before fnInitComplete

                if (cfg.hasOwnProperty('fnInitComplete'))
                    cfg.fnInitComplete();

                if (dt && dt.editor && cfg.editable) {
                    if (cfg.editable.canEdit) {
                        $('.dataTables_controls_end').prepend($('<button/>', {
                            id: 'btn-add-row',
                            class: 'btn btn-tool',
                            html: '<i class="fa fa-plus"></i> ' + T('Add Row')
                        }));
                    }
                }

                // After fnInitComplete
                select.init();
                revealDataTable();
                checkAllRowsAndToggle();
                toggleOnRowChecked();
                appn.tooltip.init();
            },
            fnDrawCallback: function () {
                // Before fnDrawCallback

                if (cfg.hasOwnProperty('fnDrawCallback'))
                    cfg.fnDrawCallback();

                if (dt && dt.editor) {
                    dt.editor.reinjectClientAddedRows();
                    dt.editor.syncUIWithState();
                }

                // After fnDrawCallback
                checkAllRowsAndToggle();
                toggleOnRowChecked();

                ui.tryResetFiltersEvent();
            },
            stateSave: cfg.hasOwnProperty('stateSave') ? cfg.stateSave : true,
            stateSaveCallback: function (oSettings: any, oData: any) {

                // Use the overriding method if its here
                if (cfg.stateSaveCallback) {
                    cfg.stateSaveCallback(oSettings, oData, getCompositeStateCacheKey(oSettings));
                    return;
                }

                // Save state
                try {
                    window.localStorage.setItem(getCompositeStateCacheKey(oSettings), JSON.stringify(oData));
                } catch (e) {

                    /* Suppress */
                    // Storage might be full
                }
            },
            stateLoadCallback: function (oSettings: any, oData: any) {

                // Use the overriding method if its here
                if (cfg.stateLoadCallback)
                    return cfg.stateLoadCallback(oSettings, getCompositeStateCacheKey(oSettings));

                // return state
                const oDataStateObj = JSON.parse(window.localStorage.getItem(getCompositeStateCacheKey(oSettings)) as any);
                return oDataStateObj;
            },
            colResize: cfg.hasOwnProperty('colResize') ? cfg.colResize : colResizeConfig
        };

        // Init datatable
        let dt: any = null;
        if (($.fn as any).dataTable.isDataTable(selector))
            dt = ($(selector) as any).DataTable();

        if (dt) {
            // Destroy it if its already created
            // This fixes an issue with Datatables for error message 'cannot reinitialize datatable'
            // This will not perform another request
            // https://datatables.net/manual/tech-notes/3
            dt.destroy();
            dt = null;
        }

        if (cfg.editable) {
            dt = { editor: new Editor(cfg.editable) };
            if (!cfg.aoColumns)
                settingObj.aoColumns = dt.editor.getMainColumns();
        }

        // Finally Init the datatable
        const $dt = ($(selector) as any).dataTable(settingObj);
        dt = $.extend($dt, dt);

        if (dt.editor) {
            dt.editor.init(dt);
        }

        // If its not an ajax table then reveal immediately.  
        // Ajax table will reveal after response from server to avoid flashing and jumping
        if (!isServer)
            appn.dataTable.revealDataTable();

        if (!cfg.noFilterKey)
            $dt.fnSetFilterKey(); // Filter on hitting return key

        return dt;
    }

    /**
     * Intercept the call to the Server and use the cached values
     * @param name
     * @param defaultValue
     */
    export function getStateOrDefault(name: string, defaultValue: any): INameValuePair {
        const pageStateRegister = appn.localStorage.getItem(appn.saveMeState.dbKey);

        const registerItem = appn.saveMeState.findItemInRegister(name, pageStateRegister);
        if (registerItem)
            return { name: name, value: (registerItem as any).value };

        return { name: name, value: defaultValue };
    }

    /**
     * Will check/uncheck all check boxes for all rows when the main check box is checked/unchecked.
     * Will also enable/disable the relevant action button
     */
    export function checkAllRowsAndToggle() {
        const checkAllCheckBox = $(_datatableCheckAllBoxSelector);
        if (checkAllCheckBox.length === 0)
            return;

        checkAllCheckBox.off().on('change', function (this: any): any {
            if ($(this).is(':checked') && $('.dataTable .selectRow').length > 0) {
                $('.dataTable .selectRow:not(:disabled)').prop('checked', true);
                ui.enableElement($('.datatable-togglebtn'));
            } else {
                $('.selectRow').prop('checked', false);
                ui.disableElement($('.datatable-togglebtn'));
            }
        });
    }

    /**
     * Will enable/disable the relevant action button when checked/unchecked
     */
    export function toggleOnRowChecked() {
        const toggleBtn = $('.datatable-togglebtn');
        if (toggleBtn.length > 0)
            // Enable/disable the manage on checking of selectRow boxes
            ui.disableElement(toggleBtn);

        const selectRow = $('.selectRow');
        if (selectRow.length === 0)
            return;

        selectRow.off().on('change', function (): void {
            if ($(this).is(':checked')) {
                ui.enableElement($('.datatable-togglebtn'));
                return;
            }

            if ($(_datatableCheckAllBoxSelector).is(':checked'))
                $(_datatableCheckAllBoxSelector).prop('checked', false);

            if ($('.selectRow:checked').length === 0)
                ui.disableElement($('.datatable-togglebtn'));
        });
    }

    /**
     * Will uncheck the all rows box
     */
    export function uncheckAllRowsBox() {
        $(_datatableCheckAllBoxSelector).prop('checked', false);
    }

    /**
     * Adds a placeholder to the datatables search input box
     * Optionally adds a hint if passed in 
     */
    export function addSearchPlaceholder(hintText?: string, hintClass?: string, placement?: string) {
        const searchInput = $('.dataTables_filter input[type="search"]');
        searchInput.attr('placeholder', T('Hit Enter to Search'));

        if (hintText)
            searchInput.attr('title', hintText);
    }

    /**
     * Will clear datatable.net internal search
     * @param tableSelector
     */
    export function clearSearch(tableSelector?: string) {
        const table = ($(tableSelector ? tableSelector : '.dataTable') as any).DataTable();
        table.search(appn.emptyString);

        // Data Feed
        $('.feed-search-container #SearchId').val(appn.emptyString);
        ui.disableElement($('.feed-search-container #SearchId'));

        // Data Map
        $('.data-map-view #SearchId').val(appn.emptyString);
    }

    /**
     * Will clear datatable.net internal search as well as remove it from the data object passed in.
     * @param tableSelector
     */
    export function clearSearchData(data: any) {
        const searchIndex = data.findIndex((d: any) => d.name === 'sSearch');
        data[searchIndex].value = appn.emptyString;
        clearSearch();

        return data;
    }

    /**
     * Resets the datatable to page 0
     * @param tableSelector
     */
    export function resetPaging(tableSelector?: string) {
        const table = ($(tableSelector ? tableSelector : '.dataTable') as any).DataTable();
        table.page(0);
    }

    /**
     * Clears datatable state from localStorage by its prefix
     */
    export function clearStateCacheFor(keyPrefix: string) {
        try {
            for (const key in window.localStorage)
                if (key.substring(0, keyPrefix.length) === keyPrefix)
                    delete window.localStorage[key];
        } catch (e2) {
            /* Suppress */
        }
    }

    /**
     * Redraw all data tables on the screen due to screen resizing
     * @param timeDelayInMilli
     */
    export function redrawOnResize(timeDelayInMilli?: number) {
        const $dataTable = $('.dataTable').not('.nested-table');
        if (!$dataTable.length)
            return;

        const datatableSettings = ($dataTable as any).DataTable().settings().init();

        if (!datatableSettings)
            return;

        if (!timeDelayInMilli) {
            ($dataTable as any).DataTable().columns.adjust();
            return;
        }

        setTimeout(function () {
            ($dataTable as any).DataTable().columns.adjust();
        }, timeDelayInMilli);
    }

    /**
     * Create dom option text with some dynamic ability
     * @param ratioLeft ratio of flex-grow for left
     * @param ratioMid ratio of flex-grow for mid
     * @param ratioRight ratio of flex-grow for right
     * @param containerClasses Custom classes for the container wrapper
     * @returns the table header sDom as per: https://datatables.net/reference/option/dom
     */
    export function genSDom(ratioLeft: number = 1, ratioMid: number = 0, ratioRight: number = 2, containerClasses: string = appn.emptyString, plugins: string = appn.emptyString, options: string = 'rtlip'): string {
        const total = ratioLeft + ratioMid + ratioRight;

        // Construct left container
        const leftContainer = ratioLeft > 0 ? `<'dataTables_controls_start r-${ratioLeft}'>` : appn.emptyString;
        // Construct mid container
        const midContainer = ratioMid > 0 ? `<'dataTables_controls_mid r-${ratioMid}'>` : appn.emptyString;
        // Construct right container
        const rightContainer = ratioRight > 0 ? `<'dataTables_controls_end r-${ratioRight}'f>` : appn.emptyString; // 'f' needs to stay in here so the filter is always in the right container

        // Construct wrapping container
        const containerBase = `dataTables_controls_container${(utils.hasValue(containerClasses) ? ` ${containerClasses}` : appn.emptyString)}`;
        const containerEmpty = `dataTables_controls_container_empty${(utils.hasValue(containerClasses) ? ` ${containerClasses}` : appn.emptyString)}`;
        const containerWrapper = total > 0 ? `'${containerBase}'` : `'${containerEmpty}'`;

        return `${plugins}<${containerWrapper}${leftContainer}${midContainer}${rightContainer}>${options}`;
    }
}
